// muutospyynnot.listaus
// Oiva-daily August 6, 2026: Role "KJ" is most likely dead code left over from
// removing a feature where education organizers could manage their permits.
// The role is set in Asianhallinta/index.jsx and currently only the test user has the role "ESITTELIJA".
// This function would get called when education organization had submitted a permit change.
// That, however, cannot happen anymore as that functionality has been removed.
// Moreover, if this function would be called, the path that it returns would not be valid anymore.
export const listaus = {
  label: "Muutospyyntölistaukseen siirtyminen",
  input: ["ytunnus"],
  run: ({ ytunnus }) => {
    return `/jarjestajat/${ytunnus}/jarjestamislupa-asia`;
  }
};
